import axios from "axios";
import { ChatRequest } from "../message";

const instance = axios.create({
    baseURL: process.env.REACT_APP_SERVICE_BASE_URL,
});

export function sendMessage(chatRequest:ChatRequest){
  return instance
    .post("/api/openAI/thread", chatRequest)
    .then((response) => {
        if(response.data.isSuccess){
            return response.data.data as ChatRequest;
        }
        else{
            throw new Error(response.data.message);
        }
    })
    .catch((error) => {
      throw new Error(error.message);
    });
}

